import React from 'react';
import { TimelineItem, ActiveFunctions } from '@/types/item';
import { cn } from '@/lib/utils';

interface ItemRowGhostProps {
  item: TimelineItem;
  activeFunctions: ActiveFunctions;
  showProjectColumn?: boolean;
}

const ItemRowGhost: React.FC<ItemRowGhostProps> = ({ 
  item, 
  activeFunctions, 
  showProjectColumn = false 
}) => {
  const PROJECT_WIDTH = 120;
  const ITEM_WIDTH = 200;
  const FUNCTION_WIDTH = 40;

  const visibleFunctions = Object.entries(activeFunctions).filter(([_, active]) => active);

  return (
    <div className="bg-background border rounded-lg shadow-lg opacity-90 flex">
      {/* Left columns */}
      <div className="flex bg-muted/50 border-r">
        {showProjectColumn && (
          <div 
            className="px-2 py-3 border-r text-xs flex items-center bg-background"
            style={{ width: `${PROJECT_WIDTH}px` }}
          >
            {item.projectName}
          </div>
        )}
        
        <div 
          className="px-2 py-3 border-r text-xs flex items-center bg-background"
          style={{ width: `${ITEM_WIDTH}px` }}
        >
          <div className="font-medium">{item.name}</div>
        </div>

        {visibleFunctions.map(([functionName]) => (
          <div 
            key={functionName}
            className="px-1 py-3 border-r text-[10px] text-center flex items-center justify-center bg-background"
            style={{ width: `${FUNCTION_WIDTH}px` }}
          >
            {functionName === 'contract' ? 'CTRACT' : functionName.toUpperCase()}
          </div>
        ))}
      </div>

      {/* Timeline preview */}
      <div className="flex-1 bg-background px-4 py-3 min-w-[200px]">
        <div className="flex items-center gap-2">
          <div className={cn(
            "h-4 rounded-sm",
            item.category === 'Sàn' && "bg-blue-500",
            item.category === 'Trần' && "bg-green-500", 
            item.category === 'Vách' && "bg-yellow-500",
            item.category === 'Mặt đứng' && "bg-red-500",
            item.category === 'Cửa' && "bg-purple-500",
            item.category === 'Furniture' && "bg-pink-500",
            item.category === 'Equip' && "bg-orange-500",
            item.category === 'event' && "bg-gray-500"
          )} style={{ width: '80px' }}></div>
          <span className="text-xs text-muted-foreground">
            {new Date(item.startDate).toLocaleDateString('vi-VN', { 
              month: 'short', 
              day: 'numeric' 
            })} - {new Date(item.endDate).toLocaleDateString('vi-VN', { 
              month: 'short', 
              day: 'numeric' 
            })}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ItemRowGhost;